var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenthumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90106 4.62709C6.1119 3.97304 6.21869 3.40059 6.21869 2.90696C6.21869 1.80742 5.78831 0.959961 5.07286 0.959961C4.68465 0.959961 4.56456 1.19142 4.41423 1.76067C4.42202 1.73088 4.33952 2.05125 4.31569 2.13696C4.2694 2.30196 4.18873 2.58154 4.07415 2.97617C4.07103 2.98672 4.0664 2.99675 4.0604 3.00596L2.74681 5.06204C2.43599 5.54841 1.97733 5.92224 1.43827 6.12859L0.862147 6.34904C0.685961 6.41652 0.539199 6.54394 0.44766 6.70891C0.356122 6.87388 0.325666 7.06584 0.361647 7.25104L0.676064 8.87263C0.713573 9.06609 0.805729 9.24476 0.941623 9.38748C1.07752 9.53019 1.25146 9.63099 1.44286 9.67792L5.22411 10.6047C5.78148 10.7412 6.37022 10.6522 6.86229 10.3569C7.35436 10.0617 7.70995 9.58407 7.85173 9.028L8.57315 6.19871C8.62056 6.01263 8.62483 5.81817 8.58563 5.63019C8.54642 5.4422 8.46479 5.26566 8.34695 5.11404C8.22911 4.96242 8.07818 4.83973 7.9057 4.75534C7.73321 4.67094 7.54372 4.62708 7.35169 4.62709H5.90106Z",
    fill: "#11895E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenthumbsup);
export default __webpack_public_path__ + "static/media/greenthumbsup.3dd72e30c8b806434f056f52e35cc3ae.svg";
export { ForwardRef as ReactComponent };